export function decodeJwtPayload(token: string): any | null {
	try {
		const parts = token.split(".")
		if (parts.length !== 3) return null

		const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/")
		const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4)

		const json = atob(padded)
		return JSON.parse(json)
	} catch {
		return null
	}
}

export function isJwtExpired(token: string, skewSeconds: number = 30): boolean {
	const payload = decodeJwtPayload(token)
	if (!payload?.exp) return true

	const nowSec = Math.floor(Date.now() / 1000)
	return payload.exp < nowSec + skewSeconds
}
